export enum Breakpoints {
    Small = '744px',
    Medium = '1024px',
    Large = '1280px',
}
